import React, { useState, useEffect } from "react";
import axios from "axios";
import "./IARecomendacoesMeta.css";

function IARecomendacoesMeta() {
  const [clienteId, setClienteId] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [campanhas, setCampanhas] = useState([]);
  const [selecionadas, setSelecionadas] = useState({});
  const [recomendacoes, setRecomendacoes] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState("");

  useEffect(() => {
    const buscarUsuarios = async () => {
      try {
        const response = await axios.get("https://welaunchyou.com.br/crm-wly/listagem_usuarios.php");
        if (response.data && Array.isArray(response.data.usuarios)) {
          setUsuarios(response.data.usuarios);
        } else {
          console.error("Formato inesperado:", response.data);
        }
      } catch (err) {
        console.error("Erro ao buscar usuários:", err);
      }
    };
    buscarUsuarios();
  }, []);

  const obterCampanhas = async () => {
    setErro("");
    setCarregando(true);
    setRecomendacoes("");
    setSelecionadas({});
    try {
      const res = await axios.get(
        `https://welaunchyou.com.br/crm-wly/api/integracoes/obter_dados_analise.php?cliente_id=${clienteId}`,
        { withCredentials: true }
      );
      console.log("📡 Campanhas recebidas:", res.data);
      setCampanhas(res.data.campanhas || []);
    } catch (err) {
      console.error("Erro ao buscar campanhas:", err);
      setErro("Erro ao buscar campanhas.");
    }
    setCarregando(false);
  };

  const gerarRecomendacoes = async () => {
    const campanhasSelecionadas = campanhas.filter((_, idx) => selecionadas[idx]);
    if (!campanhasSelecionadas.length) {
      setErro("Selecione pelo menos uma campanha para analisar.");
      return;
    }

    setCarregando(true);
    setErro("");
    setRecomendacoes("");

    console.log("🔍 Enviando campanhas para IA:", campanhasSelecionadas);

    try {
     const res = await axios.post(
  "https://welaunchyou.com.br/crm-wly/api/integracoes/gerar_recomendacoes.php",
  {
    cliente_id: clienteId, // ✅ adicionado aqui
    campanhas: campanhasSelecionadas
  },
  { withCredentials: true }
);

      if (res.data?.recomendacoes) {
        setRecomendacoes(res.data.recomendacoes);
      } else if (res.data?.error) {
        console.error("Erro da IA:", res.data.error);
        setErro("Erro da IA: " + res.data.error);
      } else {
        console.warn("Resposta inesperada da IA:", res.data);
        setErro("Erro ao interpretar resposta da IA.");
      }

    } catch (err) {
      console.error("Erro ao gerar recomendações:", err);
      setErro("Erro ao gerar recomendações.");
    }

    setCarregando(false);
  };

  return (
    <div>
      <h2 className="comissoes-titulo">🔎 Recomendação Inteligente para Tráfego Pago</h2>

      <div className="comissoes-container">
        <div className="comissoes-filtros">
          <label>Cliente:</label>
          <select
            value={clienteId}
            onChange={(e) => setClienteId(e.target.value)}
            className="comissoes-select"
          >
            <option value="">Selecione o cliente</option>
            {usuarios.map((usuario) => (
              <option key={usuario.id} value={usuario.id}>
                {usuario.nome_empresa ? usuario.nome_empresa : `ID ${usuario.id}`}
              </option>
            ))}
          </select>

          <button onClick={obterCampanhas} className="comissoes-botao">
            Obter Campanhas
          </button>
        </div>

        {carregando && <p className="comissoes-error">Carregando...</p>}
        {erro && <p className="comissoes-error">{erro}</p>}

        {campanhas.length > 0 && (
          <div>
            <h3>📊 Campanhas encontradas:</h3>
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              {campanhas.map((c, index) => (
                <li
                  key={index}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "20px 1fr",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "10px"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selecionadas[index] || false}
                    onChange={() =>
                      setSelecionadas((prev) => ({
                        ...prev,
                        [index]: !prev[index]
                      }))
                    }
                  />
                  <div>
                    <div style={{ fontWeight: "bold" }}>{c.nome}</div>
                    <div style={{ fontSize: "14px", color: "#555" }}>
                      R$ {c.custo.toFixed(2)} — Conversões: {c.conversoes}
                    </div>
                  </div>
                </li>
              ))}
            </ul>

            <button onClick={gerarRecomendacoes} className="comissoes-botao">
              Analisar com IA
            </button>
          </div>
        )}

        {recomendacoes && (
          <div className="ia-recomendacoes" style={{ marginTop: 20 }}>
            <h3>🤖 Recomendações:</h3>
            <div
              style={{
                whiteSpace: "pre-wrap",
                background: "#f4f4f4",
                padding: "10px",
                borderRadius: "6px",
                lineHeight: "1.5"
              }}
            >
              {recomendacoes}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default IARecomendacoesMeta;
